import { LinkGenerator } from "@/utils/LinkGenerator";
import { SITE_URL } from "@/misc/constants";

const messengers = [
  {
    icon: "/icons/whatsapp.svg",
    key: "wa",
    linkGenerator: LinkGenerator.whatsappBot,
  },
  {
    icon: "/icons/viber.svg",
    key: "viber",
    linkGenerator: (token) => `${SITE_URL}/viber/subscribe/${token}`,
  },
  {
    icon: "/icons/telegram.svg",
    key: "tg",
    linkGenerator: LinkGenerator.telegramBot,
  },
];
export const messengersWithDirectLinks = messengers.map((m) =>
  m.key === "viber"
    ? {
        ...m,
        linkGenerator: LinkGenerator.viberBot,
      }
    : m
);
export default messengers;
